module.exports = __webpack_public_path__ + "img/title.aded6e39.png";